import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=644f6ef0&scoped=true&"
import script from "./CarForm.vue?vue&type=script&lang=ts&"
export * from "./CarForm.vue?vue&type=script&lang=ts&"
import style0 from "./CarForm.vue?vue&type=style&index=0&id=644f6ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f6ef0",
  null
  
)

export default component.exports